import { Grid } from '@mui/material';

import type { CompletionStatusEnum } from '@/types';
import { FiltersBlock } from './FiltersBlock';
import { icons } from './Icons';

interface FilterOption<T> {
  label: string;
  value: T;
}

type FilterButtonClickHandler<T> = {
  bivarianceHack(value: T, name?: string): void;
}['bivarianceHack'];

interface TransactionSectionProps<T extends string> {
  activeValue?: T | T[];
  completionStatus: CompletionStatusEnum[];
  completionStatusOptions: FilterOption<CompletionStatusEnum>[];
  completionStatusVisible: boolean;
  dataQa: string;
  name: string;
  onCompletionStatusChange: (value: CompletionStatusEnum, name?: string) => void;
  onTransactionChange: FilterButtonClickHandler<T>;
  options: FilterOption<T>[];
  title: string;
}

export const TransactionSection = <T extends string = string>({
  activeValue,
  completionStatus,
  completionStatusOptions,
  completionStatusVisible,
  dataQa,
  name,
  onCompletionStatusChange,
  onTransactionChange,
  options,
  title,
}: TransactionSectionProps<T>) => {
  return (
    <>
      <Grid item xs={12}>
        <FiltersBlock<T>
          icon={<icons.TransactionType />}
          name={name}
          type='button'
          size='middle'
          title={title}
          options={options}
          activeButton={activeValue}
          onClick={onTransactionChange}
          dataQa={dataQa}
        />
      </Grid>
      {completionStatusVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.CompletionStatus />}
            name='completionStatus'
            type='button'
            size='middle'
            title='Completion status'
            options={completionStatusOptions}
            activeButton={completionStatus}
            onClick={onCompletionStatusChange}
            dataQa='completion_status'
          />
        </Grid>
      )}
    </>
  );
};
